import { NextPage } from 'next';

const UnityGame: NextPage = () => {
  return <></>;
};

export default UnityGame;
